import React, { useState } from "react";
import {
  Button,
  Divider,
  Form,
  Input,
  Radio,
  Select,
  Switch,
  Upload,
} from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { styled } from "styled-components";

import TitleHeader from "../../components/Common/TitleHeader";
import NormalTable from "../../components/Table/NormalTable";
import { MainText } from "../../helpers/StyledComponents";

const BOOKS = [
  "พลังประจำวัน 1 ปี (4 เล่ม) 200 บาท",
  "พลังประจำวัน 3 ปี (12 เล่ม) 550 บาท",
  "พลังประจำวัน 6 ปี (24 เล่ม) 1,000 บาท",
  "Daily Bread 1 ปี (4 เล่ม) 800 บาท",
  "Encounter With God 1 ปี (4เล่ม) 800 บาท",
  "每㈰讀經釋義 1 ปี (4เล่ม) 800 บาท",
];

const RegistrationContainer = () => {
  const [details, setDetails] = useState({});

  const onChangeDetails = (key, value) => {
    setDetails((prevDetails) => ({
      ...prevDetails,
      [key]: value,
    }));
  };
  const onRadioChange = (e) => {
    console.log(e);
  };
  console.log("details", details);
  return (
    <MainContainer>
      <TitleHeader en="REGISTRATION" th="สมัครสมาชิก" center />
      <Divider />
      <NormalTable />
      <Divider />
      <TitleHeader
        en="REGISTER HERE"
        th="กรอกแบบฟอร์ม พร้อมชำระค่าสมัครที่นี่"
        center
      />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div style={{ marginBottom: "10px" }}>
          กรุณากรอกรายละเอียดบน Google Form โดยการคลิกที่ปุ่มด้านล่าง
        </div>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://docs.google.com/forms/d/e/1FAIpQLSd6KjSRqpJWYQLgNYAPIEfkqhxSYTIDWKLhRD3dWZm1MsLUzA/viewform"
        >
          <Button type="primary">
            <div>กรอกข้อมูลผู้สมัคร</div>
          </Button>
        </a>
      </div>
      {/* <FormContainer>
        <Form
          size={"default"}
          style={{ maxWidth: 500 }}
          onValuesChange={onRadioChange}
        >
          <MainText mb="15">รายละเอียดผู้สมัคร</MainText>
          <Form.Item label={<div>รายละเอียด</div>} name="detail">
            <Radio.Group>
              <Radio.Button value="สมาชิกใหม่">
                <div>สมาชิกใหม่</div>
              </Radio.Button>
              <Radio.Button value="ต่ออายุสมาชิก">
                <div>ต่ออายุสมาชิก</div>
              </Radio.Button>
              <Radio.Button value="ให้เป็นของขวัญ">
                <div>ให้เป็นของขวัญ</div>
              </Radio.Button>
            </Radio.Group>
          </Form.Item>
          <Form.Item label={<div>หนังสือ</div>}>
            <Select>
              {BOOKS.map((i) => (
                <Select.Option key={i} value={i}>
                  <div>{i}</div>
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label={<div>ชื่อ - นามสกุลผู้สมัคร</div>}>
            <Input onChange={(e) => onChangeDetails("name", e.target.value)} />
          </Form.Item>
          <Form.Item label={<div>เป็นสมาชิกของคริสตจักร</div>}>
            <Input
              onChange={(e) => onChangeDetails("church", e.target.value)}
            />
          </Form.Item>
          <Form.Item label={<div>เบอร์โทรศัพท์</div>}>
            <Input onChange={(e) => onChangeDetails("phone", e.target.value)} />
          </Form.Item>
          <Form.Item label={<div>อีเมล์</div>}>
            <Input onChange={(e) => onChangeDetails("email", e.target.value)} />
          </Form.Item>
          <Form.Item label={<div>ที่อยู่สำหรับจัดส่ง</div>}>
            <Input.TextArea />
          </Form.Item>
          <Form.Item
            label={
              <div>โปรดคลิก หากข้อมูลผู้สมัครเหมือนกับข้อมูลผู้รับหนังสือ</div>
            }
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
        </Form>
        <Form
          size={"default"}
          style={{ maxWidth: 500 }}
          onValuesChange={onRadioChange}
        >
          <Divider />
          <MainText mb="15">รายละเอียดผู้รับหนังสือ</MainText>
          <Form.Item label={<div>ชื่อ - นามสกุลผู้รับหนังสือ</div>}>
            <Input
              onChange={(e) => onChangeDetails("recipientName", e.target.value)}
            />
          </Form.Item>
          <Form.Item label={<div>เป็นสมาชิกของคริสตจักร</div>}>
            <Input
              onChange={(e) =>
                onChangeDetails("recipientChurch", e.target.value)
              }
            />
          </Form.Item>
          <Form.Item label={<div>เบอร์โทรศัพท์</div>}>
            <Input
              onChange={(e) =>
                onChangeDetails("recipientPhone", e.target.value)
              }
            />
          </Form.Item>
          <Form.Item label={<div>อีเมล์</div>}>
            <Input
              onChange={(e) =>
                onChangeDetails("recipientEmail", e.target.value)
              }
            />
          </Form.Item>
        </Form>
        <Divider />
        <MainText mb="15">ชำระค่าสมาชิก</MainText>
        <Form.Item label={<div>วิธีการชำระเงิน</div>}>
          <Radio.Group
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: 5,
              gap: 10,
            }}
          >
            <Radio value="a">
              <div>
                โอนเงินเข้าบัญชีคริสตธรรมสัมพันธ์แห่งประเทศไทย ธนาคารกรุงเทพ
                สาขาสีลม บัญชีกระแสรายวัน เลขที่ 118-3-10460-1
              </div>
            </Radio>
            <Radio value="b">
              <div>
                ธนาณัติ สั่งจ่ายไปรษณีย์กลาง กรุงเทพฯ 10501 ในนาม
                คริสตธรรมสัมพันธ์แห่งประเทศไทย
              </div>
            </Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item name="dragger" valuePropName="fileList" noStyle>
          <Upload.Dragger name="files" action="/upload.do">
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">อัพโหลดหลักฐานการชำระเงิน</p>
            <p className="ant-upload-hint">กรุณาอัพโหลดไฟล์รูปภาพเท่านั้น</p>
          </Upload.Dragger>
        </Form.Item>
        <Divider />
        <Button type="primary">
          <div>ส่งแบบฟอร์ม</div>
        </Button>
      </FormContainer> */}
    </MainContainer>
  );
};

const MainContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

const FormContainer = styled.div`
  margin: 0px auto;
  width: 100%;
  max-width: 500px;
`;

export default RegistrationContainer;
